import React, { useEffect, useState } from 'react'
import { useMessageDetailsForm } from '../../../../../../contexts/MessageDetailsForm';
import { Breadcrumb, BreadcrumbItem } from '@livingdesign/react';
import EditFormActionsFooter from '../EditFormActionsFooter';
import EmailTemplateListContainer from './EmailTemplate/EmailTemplateListContainer';
import "./TemplateOverlay.scss";
import { useCampaignContext } from '../../../../../../contexts/Campaign';
import { useEditorContext } from '../../../../../../contexts/Editor';
import { NOTIFICATION_CHANNELS } from '../../../../../../consts/Campaign';
import { BUTTONS } from '../../../../../../consts/Template';

export const QA_ID_PREFIX = "TemplateOverlay";

function TemplateOverlay({
    open,
    handleClose,
    editSelectedTemplate,
    setEditSelectedTemplate,
}) {

    const {
        savingCampaign,
        saveTemplate,
        selectedTemplate,
    } = useCampaignContext();

    const {
        formValues,
        selectedCampaign,
        saveCampaign,
        channel,
    } = useMessageDetailsForm();

    const {
        createGalleries,
    } = useEditorContext();

    const [showEmailTemplatesList, setShowEmailTemplatesList] = useState(false);
    const [showActionsFooter, setShowActionsFooter] = useState(true);

    useEffect(() => {
        createGalleries(NOTIFICATION_CHANNELS.mail.value, selectedCampaign);
    }, []);

    useEffect(() => {
        if(!open) {
            setEditSelectedTemplate(false);
        }
    }, [open]);

    useEffect(() => {
        switch(formValues.channel) {
            case "mail":
                setShowEmailTemplatesList(true);
                break;
        }
    }, [formValues.channel]);

    const saveAndClose = async () => {
        if (savingCampaign) return;
        await saveCampaign(selectedCampaign);
        handleClose();
    };
    
    if(!open) return null;

    return (
        <main className='template-overlay' data-testid={`${QA_ID_PREFIX}-main`}>
            <div className='template-overlay-main' data-testid={`${QA_ID_PREFIX}-main-container`}>
                <Breadcrumb data-testid={`${QA_ID_PREFIX}-breadcrumb`}>
                    <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-home`}>Home</BreadcrumbItem>
                    <BreadcrumbItem
                        data-testid={`${QA_ID_PREFIX}-breadcrumb-create-new-message`}
                        onClick={async () => {
                            await saveAndClose();
                        }}
                        UNSAFE_style={{cursor: 'pointer'}}
                    >
                        Create new message
                    </BreadcrumbItem>
                    <BreadcrumbItem data-testid={`${QA_ID_PREFIX}-breadcrumb-template`}>Template</BreadcrumbItem>
                </Breadcrumb>
                {showEmailTemplatesList &&
                    <section data-testid={`${QA_ID_PREFIX}-email-templates-section`}>
                        <EmailTemplateListContainer
                            selectedCampaign={selectedCampaign}
                            selectedTemplate={editSelectedTemplate ? selectedTemplate : null}
                            channel={channel}
                            saveTemplate={saveTemplate}
                            saveButtonText={BUTTONS.SAVE}
                            setShowActionsFooter={setShowActionsFooter}
                        />
                    </section>
                }
                {showActionsFooter &&
                    <section style={{ paddingBottom: "60px" }} data-testid={`${QA_ID_PREFIX}-actions-footer-section`}>
                        <EditFormActionsFooter
                            loading={savingCampaign}
                            onPrevious={async () => {
                                await saveAndClose();
                            }}
                            onSaveDraft={() => saveCampaign(selectedCampaign)}
                            onContinue={null}
                            hideContinueButton={true} // Assuming you want to hide the continue button in this overlay
                        />
                    </section>
                }
            </div>
        </main>
    );
}

export default TemplateOverlay;